var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.checkIfDevice()
    ? _c(
        "div",
        {
          staticClass: "cursor-wrapper",
          class: {
            "cursor-wrapper--active": _vm.isHovered,
            "cursor-wrapper--white": _vm.thema === "white"
          }
        },
        [
          _c("div", { ref: "dot", staticClass: "cursor__dot" }),
          _vm._v(" "),
          _c("div", { ref: "outline", staticClass: "cursor__outline" })
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }